import React, { createContext, useContext, useRef } from 'react';
import { importIntroWidgetsAssetsPackage } from 'src/commons/utils/helpers';
import { isBtswContext, isFromBtswWc, isFromTrim } from 'src/commons/utils';

const DynamicIntroWidgetsContext = createContext<{
  loadFitFunction: (...args: any[]) => any;
}>({
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  loadFitFunction: () => {},
});

export const useDynamicIntroWidgetsContext = () => {
  const context = useContext(DynamicIntroWidgetsContext);
  if (context === null) {
    throw new Error(
      'Context must be used with DynamicIntroWidgetsContextProvider',
    );
  }
  return context;
};

export const DynamicIntroWidgetsContextProvider = ({ children }) => {
  const fitLoaded = useRef<boolean>(false);
  const loadFitFunction = () => {
    // set loading to true to prevent duplicate calls
    // We display whats new center for BTSW apps and Portal Server apps, not Partner Network apps
    if (
      !fitLoaded.current &&
      (isBtswContext() || isFromBtswWc() || isFromTrim())
    ) {
      fitLoaded.current = true;
      importIntroWidgetsAssetsPackage();
    }
  };

  return (
    <DynamicIntroWidgetsContext.Provider value={{ loadFitFunction }}>
      {children}
    </DynamicIntroWidgetsContext.Provider>
  );
};
